import { styled } from "@mui/material";

export const CountLabelStyled = styled("span")`
  font-size: 12.25px;
  line-height: 17.5px;
  color: ${({ theme }) => theme.colors.neutral.dark[700]};
`;
